import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
};

export const templateReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("GET_ALL_TEMPLATES_REQUEST", (state) => {
      state.loading = true;
    })
    .addCase("GET_ALL_TEMPLATES_SUCCESS", (state, action) => {
      state.loading = false;
      state.templatesList = action.payload.templatesList;
      state.count = action.payload.count;
    })
    .addCase("GET_ALL_TEMPLATES_ERROR", (state, action) => {
      state.loading = false;
      state.error = action;
    });
});
